// extracted by mini-css-extract-plugin
module.exports = {"input":"BasicNumberInput_input__gUdvZ","unitText":"BasicNumberInput_unitText__tLbvW"};